import { SFTPActionNames, SFTPActionTypes, SFTPState } from "./types";

const initialState = {
    dealerInfo: {

    },
    allDealerCodes: [],
    isSftpUserNotReportingAlertsEnabled: false,
    emails: [],
    rules: []
}

export const sftpReducer = (
    state: SFTPState = initialState,
    action: SFTPActionTypes,
  ): SFTPState => {
      switch (action.type) {
          case SFTPActionNames.SET_DEALER_INFO: {
              return {
                  ...state,
                  dealerInfo:  action.payload,
                  isSftpUserNotReportingAlertsEnabled: action.payload.isSftpUserNotReportingAlertsEnabled,
                  emails: action.payload.associatedEmailAddresses.map((x: string) =>({id: x, email: x})),
                  rules: action.payload.validationRules.map((x: any) => ({id: x.rule, rule: x.rule, isEnabled: x.isEnabled}))
              }
          }
          case SFTPActionNames.SET_ALL_DEALERS: {
            return {...state, allDealerCodes:action.payload}
          }
          default:
            return state;
      }
}
